import React from "react";

import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";

import NoteMediaNodeView from "components/organisms/note/extensions/NoteMediaNodeView";

const NoteImage = Node.create({
    name: "noteImage",
    group: "block",
    atom: true,
    draggable: true,

    addAttributes() {
        return {
            assetId: { default: null },
            src: { default: null },
            alt: { default: "" },
            width: { default: null },
            height: { default: null },
            align: { default: null },
        };
    },

    parseHTML() {
        return [{ tag: "img[data-note-image]" }];
    },

    renderHTML({ HTMLAttributes }) {
        const { align, height, style, width, ...restAttributes } = HTMLAttributes;
        const styles = [
            style,
            width ? `width: ${width}` : null,
            height ? `height: ${height}` : null,
            align === "left" ? "margin-left: 0; margin-right: auto" : null,
            align === "center" ? "margin-left: auto; margin-right: auto" : null,
            align === "right" ? "margin-left: auto; margin-right: 0" : null,
        ].filter(Boolean);

        return [
            "img",
            mergeAttributes(restAttributes, {
                "data-note-image": "true",
                ...(align ? { "data-note-align": align } : {}),
                ...(styles.length ? { style: styles.join("; ") } : {}),
            }),
        ];
    },

    addNodeView() {
        return ReactNodeViewRenderer((props) => <NoteMediaNodeView {...props} type="image" />);
    },
});

export default NoteImage;
